// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"Loaders_loadingSpinner__bM6oc","spin":"Loaders_spin__WpzV3","loadingSpinner__container":"Loaders_loadingSpinner__container__SfTcO"};